var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { NotificationContainer, Notifications, SuccessIcon, InfoIcon, ErrorIcon } from './styles';
const DEFAULT_NOTIFICATION_DURATION = 3000;
// Fix the SDK bug of including ASCWebSDK prefix in error messages
function omitSDKText(content) {
    return typeof content === 'string' ? content.replace('ASCWebSDK: ', '') : content;
}
const Notification = ({ className, content, icon }) => (React.createElement(NotificationContainer, { clean: true, className: className },
    icon,
    " ",
    omitSDKText(content)));
let spawnNewNotification; // for modfying NotificationContainer state outside
// rendered by provider, to allow spawning of notification from notification function below
export const NotificationsContainer = () => {
    const [notifications, setNotifications] = useState([]);
    const removeNotification = (id) => setNotifications &&
        setNotifications((prevNotifications) => prevNotifications.filter((notification) => notification.id !== id));
    spawnNewNotification = (_a) => {
        var { duration = DEFAULT_NOTIFICATION_DURATION } = _a, notificationData = __rest(_a, ["duration"]);
        const id = Date.now();
        setNotifications([Object.assign({ id }, notificationData), ...notifications]);
        setTimeout(() => removeNotification(id), duration);
    };
    return (React.createElement(Notifications, null, notifications.map((data, index) => (React.createElement(Notification, Object.assign({}, data, { key: index }))))));
};
/*
  Usage:
  notification.success({
    content: 'Report Sent',
  });

  This interface rely on NotificationsContainer being rendered by UIKITProvider in the react tree
*/
export const notification = {
    success: (data) => spawnNewNotification(Object.assign(Object.assign({}, data), { icon: React.createElement(SuccessIcon, null) })),
    info: (data) => spawnNewNotification(Object.assign(Object.assign({}, data), { icon: React.createElement(InfoIcon, null) })),
    error: (data) => spawnNewNotification(Object.assign(Object.assign({}, data), { icon: React.createElement(ErrorIcon, null) })),
    show: (data) => spawnNewNotification(data),
};
export default Notification;
//# sourceMappingURL=index.js.map